/* eslint-disable react/jsx-wrap-multilines */
import React, { Component } from 'react';
import Tree from '../../Tree';
import { countTitle } from '../utils';
import { getSysFieldid } from '@platform/api';

const TreeNode = Tree.TreeNode;

export default class ReferTree extends Component {
	static defaultProps = {
	    defaultExpandAll: false,
	    checkStrictly: true,
	    autoExpandParent: false,
	    id: 'refpk',
	    pid: 'pid',
	};

	constructor(props) {
	    super(props);
	    this.state = { expandedKeys: {} };
	}

	componentWillMount() {
	    this.propsToState(this.props);
	}

	componentWillReceiveProps(nextProps) {
	    this.propsToState(nextProps);
	}

	propsToState = props => {
	    let expandedKeys = {};
	    props.expandedKeys.forEach(e => {
	        expandedKeys[e] = true;
	    });
	    this.setState({ expandedKeys });
	};

	makeDOM = data => {
	    let { id, treeSearchKey, renderTreeTitleHighLight } = this.props,
	        { expandedKeys } = this.state;
	    if (Array.isArray(data)) {
	        return data.map(e => {
	            let title = '';
				if(typeof renderTreeTitleHighLight === 'function'){
					title = renderTreeTitleHighLight(e._display || e.refname, treeSearchKey);
				}else{
					title = countTitle(e._display || e.refname, treeSearchKey);
				}
				return (
	                <TreeNode
	                    key={e[id]}
	                    title={
	                        <span>
	                            {e.isleaf === false ? (
	                                <span
	                                    className={`refer-tree-switch iconfont ${
	                                        expandedKeys[e.refpk]
	                                            ? 'icon-wenjianjiadakai'
	                                            : 'icon-wenjianjia'
	                                    }`}
	                                />
	                            ) : (
	                                <span className="refer-tree-point" />
	                            )}
	                            <span className="refer-tree-title" fieldid={getSysFieldid('tree-title')}>{title}</span>
	                        </span>
	                    }
	                    liAttr={{ fieldid: getSysFieldid(`${e.refcode || e.refname}_node`) }}
	                    treeNodeData={e}
	                    disableCheckbox={e.disabled}
	                    isLeaf={e.isleaf !== false}
	                >
	                    {this.makeDOM(e.children)}
	                </TreeNode>
	            );
	        });
	    } else {
	        return data;
	    }
	};

	render() {
	    const {
	        treeDataWithChildren,
	        checkedKeys,
	        selectedKeys,
	        keyMap,
	        id,
	        data,
	        pid,
	        root,
	        // onFocus,
	        ...otherProps
	    } = this.props;
	    return (
	        <Tree
	            showLine
	            focusable
	            checkedKeys={(Array.isArray(checkedKeys) ? checkedKeys : []).filter(
	                e => keyMap[e],
	            )}
	            selectedKeys={(Array.isArray(selectedKeys) ? selectedKeys : []).filter(
	                e => keyMap[e],
	            )}
	            {...otherProps}
	            treeData={treeDataWithChildren}
	            lazyLoad
	            renderTreeNodes={data => {
	                return this.makeDOM(data);
	            }}
	        >
	            {/* {this.makeDOM(treeDataWithChildren)} */}
	        </Tree>
	    );
	}
}
